import { RouteLocation } from "vue-router"

export default [
  {
    path: "/dashboard-layout-home",
    component: () => import("@/layouts/dashboard/DashboardLayout.vue"),
    children: [
      {
        path: "/coverage",
        name: "coverage",
        props: (route: RouteLocation) => ({
          benefitPlanName: route.query.benefitPlanName
        }),
        component: () => import("@/modules/care-navigation/pages/coverage-list/CoverageCardsPage.vue")
      },
      {
        path: "/coverage/:benefitPlanName",
        name: "coverage-details",
        props: true,
        component: () => import("@/modules/care-navigation/pages/coverage-details/CoverageDetailsPage.vue")
      },
      {
        path: "/medications",
        name: "medications",
        component: () => import("@/modules/care-navigation/pages/medication-coverage/MedicationCoverage.vue")
      }
    ]
  }
]
